import script from "./Figure.vue?vue&type=script&lang=ts&setup=true"
export * from "./Figure.vue?vue&type=script&lang=ts&setup=true"

import "./Figure.vue?vue&type=style&index=0&id=36fbee47&lang=postcss&scope=true"

const __exports__ = script;

export default __exports__